import React, { FC, useState, useEffect, useContext } from 'react'


import GenericBackgroundLayer from '../../../GenericComponents/GenericBackgroundLayer'

interface ChallengesAlbumScreenInterface { }

const ChallengesAlbumScreen: FC<ChallengesAlbumScreenInterface> = ({ }) => {


  return (
    <GenericBackgroundLayer
      fDir={'column'}
      justify={'flex-start'}
      align={'center'}

    >

    </GenericBackgroundLayer>
  )
}

export default ChallengesAlbumScreen
